<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="page-header-container">
        <h2>{{ 'common.partners_and_customers' | translate }}</h2>
        <div class="header-accent-line"></div>
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-12">
      <div class="partners-wrapper">
        
        <p *ngIf="loading else partnersList" class="text-center py-4">
          <label class="text-muted"><i class="fa fa-spinner fa-spin mr-2"></i>{{ 'common.loading' | translate }} ...</label>
        </p>

        <ng-template #partnersList>
          <div class="row justify-content-center align-items-center g-4">
            
            <div *ngFor="let partner of partners" class="col-6 col-sm-4 col-md-3 col-lg-2">
              <div class="partner-logo-container">
                
                <img *ngIf="partner.image_path" 
                     [src]="partner.image_path" 
                     [alt]="partner.name" />
                     
                <div *ngIf="!partner.image_path" class="partner-placeholder">
                  <span>{{ partner.name }}</span>
                </div>
                
              </div>
            </div>
            
          </div>

          <div *ngIf="partners.length === 0" class="text-center py-5">
            <p class="lead text-muted">{{ 'common.no_partners' | translate }}</p>
          </div>
        </ng-template>
        
      </div>
    </div>
  </div>
</div>